import moment from 'moment'

export default function (format, value) {
  return moment(value, format).isValid() ? value : null
}
